import { useDispatch } from "react-redux"
import Modal from "@/components/Modal"
import { closeErrorModal } from "@/redux/features/errorModalSlice"
import { openModal, closeModal } from "@/redux/features/modalSlice"
import { useAppSelector } from "@/redux/hooks"

export default function ErrorModal() {
  const dispatch = useDispatch()
  const { isOpen, errors } = useAppSelector((state: any) => state.errorModal)

  if (!isOpen) return null
  // need to set the modal state to open as well as the error modal state
  dispatch(openModal())

  return (
    <Modal
      title="Subscription Errors"
      onClose={() => {
        dispatch(closeErrorModal())
        dispatch(closeModal())
      }}
    >
      <div style={{ fontSize: 48, textAlign: "center" }}>😔</div>
      <h1>Uh-oh...</h1>
      <div
        style={{
          maxHeight: 400,
          overflowY: "scroll",
          textAlign: "left",
          marginTop: 16,
        }}
      >
        {errors.map((error: string, i: number) => (
          <p
            key={i}
            style={{ fontSize: 10 }}
            dangerouslySetInnerHTML={{ __html: error }}
          />
        ))}
      </div>
    </Modal>
  )
}
